// extracted by mini-css-extract-plugin
module.exports = {"search-bar-result-item":"ItemList_search-bar-result-item__1lt1d","search-bar-result-item-text":"ItemList_search-bar-result-item-text__2tqd3"};